import axios from "axios";

const get_Location = (setLocationOption, setUserLoader) => {
  setUserLoader(true);
  var axios = require("axios");

  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Locations/GetLocations`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  };

  axios(config)
    .then(function (response) {
      setLocationOption(response.data);
      setUserLoader(false);
      // setRoleoptions(
      //   response.data.map((item, i) => {
      //     return {
      //       value: item.id,
      //       label: item.name,
      //     };
      //   })
      // );
    })
    .catch(function (error) {
      setUserLoader(false);
    });
};

const getUserByLocation = async (
  apiString,
  locid,
  setgetUserdata,
  setStatusLoading
) => {
  setStatusLoading(true);

  const data = {
    RoleName: apiString?.toString(),
    LocationId: locid?.toString(),
  };
  var axios = require("axios");

  await axios({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/api/Role/GetUserListLocationWise_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
    params: data,
  })
    .then(function (response) {
      setgetUserdata(response.data);

      setStatusLoading(false);
    })
    .catch(function (error) {
      setStatusLoading(false);
    });
};

const create_user = async (
  setFormState,
  formState,
  setUserLoader,
  setSuccessMessage,
  setErrorMessage,
  getData,
  setgetUser,
  handleCloseModel,
  seterror,
  userId
) => {
  var data = {
    id: userId ? userId : 0,
    location_Id: formState.location,
    user_Id: formState.userName,
    limit: formState.limit,
    created_By: "string",
    created_On: null,
    updated_By: "string",
    updated_On: null,
  };

  if (
    formState?.location === "" ||
    formState?.userName === "" ||
    formState?.limit === ""
  ) {
    seterror(true);
  } else {
    setUserLoader(true);
    await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/APSConfigurations/PostAPSConfiguration`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      data: data,
    })
      .then(function (response) {
        userId
          ? setSuccessMessage("user has been updated")
          : setSuccessMessage(response.data);
        getData(setgetUser, () => {});
        setUserLoader(false);
        handleCloseModel();
        setFormState({
          location: "",
          userName: "",
          limit: "",
        });
        seterror(false);
      })
      .catch(function (error) {
        setUserLoader(false);
        setErrorMessage(error.response.data);
        seterror(false);
      });
  }
};
const getData = async (setgetUser, setstatusLoading, setSearchAPi) => {
  setstatusLoading(true);

  await axios({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/APSConfigurations/GetAPSConfiguration`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  })
    .then(function (response) {
      setgetUser(response.data);
      setSearchAPi(response.data);
      setstatusLoading(false);
    })
    .catch(function (error) {
      setstatusLoading(false);
    });
};
const DeleteUser = async (
  deleteId,
  setUserLoader,
  getData,
  setgetUser,
  handleCloseModel
) => {
  setUserLoader(true);

  await axios({
    method: "Delete",
    url: `${process.env.REACT_APP_API_URL}/api/APSConfigurations/DeleteAPSConfiguration/${deleteId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  })
    .then(function (response) {
      getData(setgetUser, () => {});

      setUserLoader(false);
      handleCloseModel();
    })
    .catch(function (error) {
      setUserLoader(false);
    });
};

const fetch_data_by_id = async (
  Id,
  locationOption,
  getUserByLocation,
  setgetUserdata,
  setStatusLoading,
  setFormState
) => {
  // setUserLoader(true)

  await axios({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/APSConfigurations/GetAPSConfiguration/${Id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    },
  })
    .then(function (res) {
      const loc = locationOption.filter((element) => {
        return element.location === res.data[0].location;
      });

      setFormState((formState) => ({
        ...formState,
        location: loc[0]?.id,
        userName: res.data[0].userId,
        limit: res.data[0].limit,
      }));
      getUserByLocation("AP Supervisor", loc[0]?.id, setgetUserdata, () => {});
    })
    .catch(function (error) {
      // setUserLoader(false);
    });
};

export {
  get_Location,
  getUserByLocation,
  create_user,
  getData,
  DeleteUser,
  fetch_data_by_id,
};
